import { FALLBACK_LANGUAGE, FALLBACK_MARKETPLACE } from '../constants';
export const NAME = 'tolgee';
export const DEFAULT_STATE = {
    language: FALLBACK_LANGUAGE,
    marketplace: FALLBACK_MARKETPLACE,
    ssrStaticData: [],
};
